import stepsJSON from '~/StepsJSon/steps-buy-page.json'
export const state = () => ({
  steps: [],
  currentStep: null,
  currentStepNumber: null,
  reachedStepNumber: 0,
  previousStepLink: '',
  nextStepLink: '',
  currentSteps: [],
  currentStepMaxCards: null,
  currentStepMinCards: null,
  isRedirectNext: false,
  isRedirectBack: false,
  currentStepIsValid: true,
  isFinalStep: false,
  isNextActionCustom: false,
})
export const mutations = {
  setSteps(state, payload) {
    state.steps = payload.sort((a, b) => a.Order.toString().localeCompare(b.Order.toString()))
  },
  setCurrentStep(state, payload) {
    state.currentStep = payload
  },
  setCurrentStepNumber(state, payload) {
    state.currentStepNumber = payload
  },
  setCurrentSteps(state, payload) {
    state.currentSteps = payload
  },
  setCurrentStepMaxCards(state, payload) {
    state.currentStepMaxCards = payload
  },
  setCurrentStepMinCards(state, payload) {
    state.currentStepMinCards = payload
  },
  setPreviousStepLink(state, payload) {
    state.previousStepLink = payload
  },
  setNextStepLink(state, payload) {
    state.nextStepLink = payload
  },
  setReachedStepNumber(state, payload) {
    state.reachedStepNumber = payload
  },
  setIsisRedirectNext(state) {
    state.isRedirectNext = !state.isRedirectNext
  },
  setIsRedirectBack(state) {
    state.isRedirectBack = !state.isRedirectBack
  },
  setCurrentStepIsValid(state, payload) {
    state.currentStepIsValid = payload
  },
  setIsFinalStep(state, payload) {
    state.isFinalStep = payload
  },
  setIsNextActionCustom(state, payload) {
    state.isNextActionCustom = payload
  },
}

export const actions = {
  /* async getSteps({ commit }) {
    try {
      const response = await client.getEntries({
        content_type: 'steps',
        // locale: 'de'
      })

      if (response.items.length > 0) {
        commit(
          'setSteps',
          response.items.map((el) => el.fields)
        )
      }
    } catch (error) {
      // you could redirect to custom error page for instance
      console.error(error)
    }
  }, */

  async getSteps({ commit }) {
    await commit('setSteps', stepsJSON.steps)
  },
}

export const getters = {
  getStepsList() {
    return this.state.steps
  },
}
